{
  "version": 1,
  "asset_id": "e5fb1310-510a-4ab2-b181-26e182d71fa4",
  "project_id": "b5943ba6-0f61-4928-b23c-a966ef99f6df",
  "url": "/__l5e/assets-v1/e5fb1310-510a-4ab2-b181-26e182d71fa4/reel-1.mp4",
  "r2_key": "a/v1/b5943ba6-0f61-4928-b23c-a966ef99f6df/e5fb1310-510a-4ab2-b181-26e182d71fa4/reel-1.mp4",
  "original_filename": "reel-1.mp4",
  "size": 953482,
  "content_type": "video/mp4",
  "created_at": "2026-08-19T12:43:46Z"
}
